import { supabase } from '@/lib/supabase';

export interface NewsItem {
  id: number;
  title: string | null;
  content: string | null;
  image: string | null;
  created_at: string;
}

export const newsService = {
  /**
   * Fetch the latest news item from Supabase
   * Ordered by created_at DESC, limit 1
   */
  async getLatestNews(): Promise<NewsItem | null> {
    try {
      const { data, error } = await supabase
        .from('news')
        .select('id, title, content, image, created_at')
        .order('created_at', { ascending: false })
        .limit(1);

      if (error) {
        // Supabase handled the request, returned an error response
        // Do not use console.error - this is not a code bug
        return null;
      }

      // Return the first item from the array, or null if empty
      return data && data.length > 0 ? data[0] : null;
    } catch (error) {
      // Network/infrastructure failures - not code bugs
      if (error?.message?.includes('Failed to fetch') || 
          error?.message?.includes('NetworkError') ||
          error?.name === 'TypeError' && error?.message?.includes('fetch')) {
        // Infrastructure issue, not a code bug - do not log
        return null;
      }
      
      // Only log actual TypeScript runtime errors (code bugs)
      console.error('TypeScript error in newsService:', error);
      return null;
    }
  },
};